/* eslint-disable import/prefer-default-export */
export enum HorizontalAlignment {
	Left,
	Right,
}

export enum VerticalAlignment {
	Top,
	Middle,
	Bottom,
}
